// App.js
import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Header from "./components/Header";
import Home from "./pages/home";
import Contact from "./pages/ContactUs";
import About from "./pages/About";
import TeacherRegistration from "./pages/teacherregistration";
import StudentRegistration from "./pages/studentregistration";
import Membership from "./pages/membership";
import Layout from "./Dashboard/Layout";
import Overview from "./Dashboard/pages/Overview";
import PublicLayout from "./pages/PublicLayout";
import Lessons from "./Dashboard/pages/Lessons";
import TeacherList from "./Dashboard/pages/TeacherList";
import Subscription from "./Dashboard/pages/Subscription";
import Replays from "./Dashboard/pages/Replays";
import BookingConfirmation from "./Dashboard/pages/BookingConfirmation";

import Setting from "./Dashboard/pages/Setting";
import Support from "./Dashboard/pages/Support";

// Teacher Dashboard Imports

import TeacherOverview from "./teacher_dashboard/pages/Overview";
import TeacherLessons from "./teacher_dashboard/pages/Lessons";
import { useSelector } from "react-redux";
import ProtectedRoute from "./utilis/auth";
import Bookings from "./teacher_dashboard/pages/Bookings";
import RecordedLessons from "./teacher_dashboard/pages/RecordedLessons";
import Earnings from "./teacher_dashboard/pages/Earnings";
import TPractice from "./teacher_dashboard/pages/Practice";
import TSettings from "./teacher_dashboard/pages/Settings";
import TSupport from "./teacher_dashboard/pages/Support";
import Availability from "./teacher_dashboard/pages/Availability";
import TProfile from "./teacher_dashboard/pages/TProfile";
import AdminOverview from "./admin/pages/AdminOverview";
import Students from "./admin/pages/Students";
import Teacher from "./admin/pages/Teacher";
import User from "./admin/pages/User";
import Upcoming from "./Dashboard/pages/Upcoming";
import Success from "./pages/Success";
import BookingSuccess from "./Dashboard/pages/Bookingsuccess";
import Queries from "./admin/pages/Queries";
function App() {
  const { role } = useSelector((state) => state.auth);
  return (
    <Router>
      <Routes>
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/membership" element={<Membership />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/About" element={<About />} />
          <Route path="/success" element={<Success />} />

          <Route
            path="/teacher-registration"
            element={<TeacherRegistration />}
          />
          <Route
            path="/student-registration"
            element={<StudentRegistration />}
          />
        </Route>
        {/* Protected Dashboard Routes */}
        <Route element={<ProtectedRoute />}>
          <Route path="/dashboard" element={<Layout />}>
            <Route
              index
              element={
                role === "admin" ? (
                  <Navigate to="/dashboard/admin" replace />
                ) : role === "teacher" ? (
                  <Navigate to="/dashboard/teacher" replace />
                ) : (
                  <Navigate to="/dashboard/student" replace />
                )
              }
            />
            <Route path="student" element={<Overview />} />
            <Route
              path="student/booking-confirmation"
              element={<BookingConfirmation />}
            />
            <Route path="student/lessons" element={<Lessons />} />
            <Route path="student/teachers" element={<TeacherList />} />
            <Route path="student/subscriptions" element={<Subscription />} />
            <Route path="student/replays" element={<Replays />} />
            <Route path="student/upcoming" element={<Upcoming />} />
            <Route path="student/settings" element={<Setting />} />
            <Route
              path="student/booking-success"
              element={<BookingSuccess />}
            />

            <Route path="student/support" element={<Support />} />

            {/* Teacher Routes */}
            <Route path="teacher" element={<TeacherOverview />} />
            <Route path="teacher/profile" element={<TProfile />} />

            <Route path="teacher/lessons" element={<TeacherLessons />} />
            <Route path="teacher/availability" element={<Availability />} />
            <Route path="teacher/bookings" element={<Bookings />} />
            <Route path="teacher/replays" element={<RecordedLessons />} />
            <Route path="teacher/payments" element={<Earnings />} />
            <Route path="teacher/practice" element={<TPractice />} />
            <Route path="teacher/settings" element={<TSettings />} />
            <Route path="teacher/support" element={<TSupport />} />

            {/* Admin Routes */}
            <Route path="admin" element={<AdminOverview />} />
            <Route path="admin/students" element={<Students />} />
            <Route path="admin/teacher" element={<Teacher />} />
            <Route path="admin/users" element={<User />} />
            <Route path="admin/queries" element={<Queries />} />
          </Route>
        </Route>
        {/* Teacher Dashboard Routes */}
        {/* <Route path="/teacher-dashboard" element={<TeacherLayout />}>
          
        </Route> */}
      </Routes>
    </Router>
  );
}

export default App;
